import type { StateCreator } from 'zustand';
import {
  linkedinAccountsApi,
  type LinkedInAccount,
  type LinkedInAccountInput,
} from '../services/linkedinAccountsApi';

const SEL_KEY = 'fraud0SelectedLinkedInAccount';
function loadSelectedAccount(): number | null {
  const v = localStorage.getItem(SEL_KEY);
  return v ? Number(v) : null;
}

export interface LinkedInAccountsSlice {
  linkedinAccounts: LinkedInAccount[];
  linkedinAccountsLoading: boolean;
  linkedinAccountsError: string | null;
  // Gewählter Sende-Account (Picker im fraud0-Kopf) — global + persistent (localStorage), damit die
  // Karte beim FR-Angebot weiß, welcher Account gestempelt wird. Pflicht: ohne Wahl wird FR blockiert.
  selectedLinkedInAccountId: number | null;
  setSelectedLinkedInAccountId: (id: number | null) => void;

  fetchLinkedInAccounts: (includeArchived?: boolean) => Promise<void>;
  createLinkedInAccount: (data: LinkedInAccountInput) => Promise<LinkedInAccount>;
  updateLinkedInAccount: (id: number, data: LinkedInAccountInput) => Promise<void>;
  deleteLinkedInAccount: (id: number) => Promise<void>;
}

export const createLinkedInAccountsSlice: StateCreator<
  LinkedInAccountsSlice,
  [],
  [],
  LinkedInAccountsSlice
> = (set, get) => ({
  linkedinAccounts: [],
  linkedinAccountsLoading: false,
  linkedinAccountsError: null,
  selectedLinkedInAccountId: loadSelectedAccount(),
  setSelectedLinkedInAccountId: (id) => {
    if (id == null) localStorage.removeItem(SEL_KEY);
    else localStorage.setItem(SEL_KEY, String(id));
    set({ selectedLinkedInAccountId: id });
  },

  fetchLinkedInAccounts: async (includeArchived = false) => {
    set({ linkedinAccountsLoading: true, linkedinAccountsError: null });
    try {
      const linkedinAccounts = await linkedinAccountsApi.list(includeArchived);
      set({ linkedinAccounts });
    } catch (e) {
      set({ linkedinAccountsError: (e as Error).message });
    } finally {
      set({ linkedinAccountsLoading: false });
    }
  },

  createLinkedInAccount: async (data) => {
    const created = await linkedinAccountsApi.create(data);
    await get().fetchLinkedInAccounts();
    return created;
  },

  updateLinkedInAccount: async (id, data) => {
    await linkedinAccountsApi.update(id, data);
    await get().fetchLinkedInAccounts();
  },

  deleteLinkedInAccount: async (id) => {
    await linkedinAccountsApi.remove(id);
    await get().fetchLinkedInAccounts();
  },
});
